import { render } from "./IconUpgrade.vue?vue&type=template&id=562db43d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconUpgrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "562db43d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('562db43d', __exports__)) {
    api.reload('562db43d', __exports__)
  }
  
  module.hot.accept("./IconUpgrade.vue?vue&type=template&id=562db43d", () => {
    api.rerender('562db43d', render)
  })

}


export default __exports__